// It probably would be better to move this configuration to the settings,
// but I would like to test plugin approach first and see if it works for us,
// and then we will decide if we want to configure it through the settings. This one is for MVP.

export const PLUGIN_CONFIGS: Record<string, string> = {
  '124980': 'GEB',
  '639526': 'GEB',
  '748918': 'GEB',
  '789028': 'GEB',
  '148759': 'GEB',
  '584543': 'GEB',
  '558674': 'GEB',
  '863261': 'GEB',
  '719406': 'GEB',
  '162646': 'GEB',
  '114621': 'GEB',
  '770055': 'GEB',
  '596280': 'GEB',
  '359035': 'BCOM',
  '756974': 'JJK',
  '206843': 'JJK',
}
